import "./pricingResult.css";
import React, { useState, useEffect } from "react";
import ScrollableComponent from "../ScrollableComponent";

export default function PricingResult({
  data = [],
  setSelectedTab,
  setPricingData,
}) {
  const [error, setError] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const storedModel = localStorage.getItem("model");
  const pricingData = JSON.parse(localStorage.getItem("pricingData"));

  useEffect(() => {
    console.log("Data received in PricingResult:", JSON.stringify(data));
    if (!data || data.length === 0) {
      setError("No data available for pricing result.");
      return;
    } else {
      setFilteredData(data.parts);
      setPricingData(pricingData);
    }
  }, [data]);

  const closeErrorPopup = () => {
    setError("");
    setSelectedTab("PRICING RESULT");
  };

  const renderColumnContent = (item) => {
    if (item.partFoundIndicator === "U") {
      if (item.location === "NLA") {
        return (
          <span>
            {" "}
            - Part Unavailable for ordering - Parts No Longer Available.
          </span>
        );
      } else if (item.location === "B/L") {
        return <span>- Part Unavailable for ordering - Buy Locally.</span>;
      } else if (item.location === "F/L") {
        return (
          <span> - Part Unavailable for ordering - Fabricate Locally.</span>
        );
      } else if (item.location === "R/L") {
        return <span>- Part Unavailable for ordering - Repair Locally.</span>;
      } else if (item.location === "S/U") {
        return (
          <span>
            - Part Unavailable for ordering - Part is Special Unavailable.
          </span>
        );
      } else if (item.location === "") {
        return <span>- Part Unavailable for ordering.</span>;
      }
    } else if (item.partFoundIndicator === "P") {
      if (item.location === "") {
        return <span> - Part Number Not Found</span>;
      }
    } else if (item.partFoundIndicator === "S") {
      if (item.location !== "") {
        return (
          <span>
            - Substituted for {item.originalDiv} {item.originalPls}{" "}
            {item.originalPartNumber} - SPI - BIN = {item.location} ,QTY ={" "}
            {item.qunatity}
          </span>
        );
      }
    } else if (item.partFoundIndicator === "O") {
      if (item.location !== "") {
        return (
          <span>
            {" "}
            - SPI - BIN = {item.location} ,QTY = {item.qunatity}
          </span>
        );
      }
    } else {
      return <span>{item.partNumberInformation}</span>;
    }
  };

  const calculateTotal = (data, field) => {
    if (!Array.isArray(data) || data.length === 0) {
      return "0.00";
    }

    const total = data.reduce((sum, item) => {
      const value = parseFloat(item[field]) || 0;
      return sum + value;
    }, 0);

    return total.toFixed(2);
  };

  return (
    <div>
      <ScrollableComponent height="500px">
        <table className="pricingResult" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>Div</th>
              <th>Pls</th>
              <th>Part Number</th>
              <th>Part Number Information</th>
              <th>Description</th>
              <th>Quantity</th>
              <th>Price</th>
              <th>Extended Price</th>
              <th>Model</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            {filteredData && filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.partFoundIndicator === "S"
                      ? item.fpdSubstituteDivision
                      : item.originalDiv}
                  </td>
                  <td>
                    {item.partFoundIndicator === "S"
                      ? item.fpdSubstitutePLS
                      : item.originalPls}
                  </td>
                  <td>
                    {item.partFoundIndicator === "S"
                      ? item.fpdSubstitutePartNumber
                      : item.originalPartNumber}
                  </td>
                  <td>{renderColumnContent(item)}</td>
                  <td>{item.partDescription}</td>
                  <td>{item.qunatity}</td>
                  <td>
                    {item.partFoundIndicator === "S"
                      ? item.subbedPartsSell
                      : item.originalPartsSell}
                  </td>
                  <td>
                    {item.calculatedPrice ? (
                      <span>{item.calculatedPrice}</span>
                    ) : (
                      <span>- 0.00</span>
                    )}
                  </td>
                  <td>{JSON.parse(storedModel)}</td>
                  <td>{item.location}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10">No data available</td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="7" align="right">
                <b>Total</b>
              </td>
              <td>{calculateTotal(filteredData, "calculatedPrice")}</td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </ScrollableComponent>
    </div>
  );
}
